import React from "react";
import { dialog, Button } from "nq-component";
import Table from "../../../../../components/Table";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../../usecases/object";
import { InfiniteScroll } from "nq-component";
import withRouter from "../../../../../withRouter";
import BaseListPage from "../../../../../base/BaseListPage";
import InputFactory from "../../../../../components/InputFactory";
import AdditionalTalbePresenter from "../additional-info/AdditionalTalbePresenter";
import { DialogConfirmation } from "../../../../../components/common/Converter";
import Progress from "../../../../../components/Progress";

class VoluntaryPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new AdditionalTalbePresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.state = {
      objects: [],
      initialData: [],
      voluntaryOrganization: "",
      voluntaryPosition: "",
      voluntaryHours: "",
      objectID: "",
      email: sessionStorage.getItem("email"),
      count: 0,
      limit: 10,
      current: 1,
    };
  }

  getCollectionName() {
    return "voluntary_work";
  }

  getCurrent() {
    return this.props.object.id;
  }

  async componentDidMount() {
    this.presenter.componentDidMount();
    const newObject = await findObjectUseCase().execute("voluntary_work", {
      where: { empID: this.props.object.id },
    });
    this.setState({ initialData: newObject });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.objects !== this.state.objects) {
      const initialEmails = new Set(
        this.state.initialData.map((data) => data.voluntaryOrganization)
      );
      const newObjects = this.state.objects.filter(
        (data) => !initialEmails.has(data.voluntaryOrganization)
      );

      if (newObjects.length > 0) {
        localStorage.setItem("Voluntary", JSON.stringify(newObjects));
      }
    }
  }

  // delete function
  async handleDeleteData(data) {
    // const deletedData = await findObjectUseCase().execute("voluntary_work", {
    //   where: { id: id },
    // });
    // const prevDelete =
    //   JSON.parse(localStorage.getItem("DeleteVoluntary")) || [];
    // const updatedDeleteData = prevDelete.concat(deletedData);
    // localStorage.setItem("DeleteVoluntary", JSON.stringify(updatedDeleteData));

    // await this.presenter.deleteObjectUseCase.execute("voluntary_work", id);
    // dialog.close();
    // this.refetchData();
    DialogConfirmation(data.id, this.getCollectionName(), () =>
      this.refetchData()
    );
  }

  // edit function
  handleObjectData(object) {
    this.setState({
      objectID: object.id,
      voluntaryOrganization: object.voluntaryOrganization || "",
      voluntaryPosition: object.voluntaryPosition || "",
      voluntaryHours: object.voluntaryHours || "",
      voluntaryFrom: object.from || undefined,
      voluntaryTo: object.to || undefined,
    });
    dialog.fire({
      html: (
        <>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              this.handleSaveButton();
            }}
          >
            <div className="p-2">
              <h4>Add Voluntary Work</h4>
              <hr />

              <label style={{ fontSize: "12px", paddingBottom: "10px" }}>
                Name & Address of Organization (Write in full){" "}
                <span style={{ color: "red" }}>*</span>
              </label>
              <InputFactory
                type="String"
                required
                field="voluntaryOrganization"
                defaultValue={object.voluntaryOrganization}
                // object={object}
                onChange={(value) =>
                  this.onChangeForm("voluntaryOrganization", value)
                }
              />

              <label style={{ fontSize: "12px", paddingBottom: "10px" }}>
                Position/Nature of Work
              </label>
              <InputFactory
                type="String"
                field="voluntaryPosition"
                defaultValue={object.voluntaryPosition}
                // object={object}
                onChange={(value) =>
                  this.onChangeForm("voluntaryPosition", value)
                }
              />

              <label style={{ fontSize: "12px", paddingBottom: "10px" }}>
                Number of Hours
              </label>
              <InputFactory
                type="Number"
                field="voluntaryHours"
                defaultValue={object.voluntaryHours}
                // object={object}
                onChange={(value) => this.onChangeForm("voluntaryHours", value)}
              />

              <div style={{ margin: "1rem 0" }}>
                <h4>Inclusive Dates (mm/dd/yyyy)</h4>
              </div>

              <label style={{ fontSize: "12px", paddingBottom: "10px" }}>
                From
              </label>
              <InputFactory
                type="Date"
                field="voluntaryFrom"
                object={object}
                onChange={(value) => this.onChangeForm("voluntaryFrom", value)}
              />
              <label style={{ fontSize: "12px", paddingBottom: "10px" }}>
                To
              </label>
              <InputFactory
                type="Date"
                field="voluntaryTo"
                object={object}
                onChange={(value) => this.onChangeForm("voluntaryTo", value)}
              />

              <div className="mt-4 mb-4 d-flex justify-content-end">
                <button
                  type="button"
                  className="btn btn-light fs-sm me-3"
                  onClick={() => dialog.close()}
                >
                  Cancel
                </button>
                <button type="submit" className="btn btn-primary fs-sm me-3">
                  Save
                </button>
              </div>
            </div>
          </form>
        </>
      ),
      footer: false,
    });
  }

  onChangeForm(field, value) {
    this.setState({ [field]: value });
  }

  async handleSaveButton() {
    if (this.state.objectID !== "" && this.state.objectID !== undefined) {
      const data = {
        email: this.props.object.email,
        empID: this.props.object.id,
        voluntaryOrganization: this.state.voluntaryOrganization,
        voluntaryPosition: this.state.voluntaryPosition,
        voluntaryHours: this.state.voluntaryHours,
        voluntaryFrom: this.state.voluntaryFrom,
        voluntaryTo: this.state.voluntaryTo,
        id: this.state.objectID,
      };
      await this.presenter.upsertUseCase.execute("voluntary_work", data);
      dialog.close();
      this.refetchData();
      this.setState({ objectID: "" });
    } else {
      const data = {
        email: this.props.object.email,
        empID: this.props.object.id,
        voluntaryOrganization: this.state.voluntaryOrganization,
        voluntaryPosition: this.state.voluntaryPosition,
        voluntaryHours: this.state.voluntaryHours,
        voluntaryFrom: this.state.voluntaryFrom,
        voluntaryTo: this.state.voluntaryTo,
      };
      console.warn("DATAAA: ", this.state.objectID);
      await this.presenter.upsertUseCase.execute("voluntary_work", data);
      dialog.close();
      this.refetchData();
    }
  }

  async refetchData() {
    const objecst = await this.presenter.getObjects();
    return objecst;
  }
  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, loading, count, current, limit } = this.state;

    if (!schema) return <Progress />;
    // const user = this.getCurrentUser();
    return (
      <>
        <div className="overflow-auto">
          <InfiniteScroll
            className="h-100"
            loadMore={this.loadMore.bind(this)}
            // hasMore={!progress && count > objects.length}
          >
            <div className="p-3 p-lg-4">
              <div
                style={{
                  marginTop: "20px",
                  width: "100%",
                }}
              >
                <div className="d-flex align-items-center justify-content-center">
                  <div style={{ marginLeft: "auto" }}>
                    <Button
                      // onClick={this.handleAddRegion.bind(this)}
                      onClick={this.handleObjectData.bind(this)}
                    >
                      <i className="bi bi-plus-lg" /> Add Voluntary Work
                    </Button>
                  </div>
                </div>
              </div>

              <Table
                objectId={(data) => this.handleDeleteData(data)}
                objectData={this.handleObjectData.bind(this)}
                // editId={this.handleEditData.bind(this)}
                progress={loading}
                refetch={this.refetchData.bind(this)}
                fields={schema.fields}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                loadPagination={this.onClickPagination.bind(this)}
                actionsList={[
                  {
                    label: "Remove",
                    actionType: "delete",
                  },
                  {
                    label: "Edit",
                    actionType: "object",
                  },
                ]}
                // selectable
                // collapsable
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      case "Array":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  ["id", "Created At", "Updated At"]
                )}
                // selected={selected}
                // onSelect={this.onSelect.bind(this)}
                // onSelectAll={this.onSelectAll.bind(this)}
                // progress={progress}
                onClickItem={this.onClickItem.bind(this)}
              />
            </div>
          </InfiniteScroll>
        </div>
      </>
    );
  }
}

export default VoluntaryPage;
